import React from "react";

const useViewport = () => {
  const [viewMode, setViewMode] = React.useState<"mobile" | "desktop" | "">("");

  React.useEffect(() => {
    if (window && typeof window === "object" && Boolean(window?.innerWidth)) {
      setViewMode(window?.innerWidth < 786 ? "mobile" : "desktop");
    }
  }, []);

  return viewMode;
};

export default useViewport;
